export default __webpack_public_path__ + "static/media/slide4.d815e906.jpg";